import { render, staticRenderFns } from "./CreatePasswordForm.vue?vue&type=template&id=6fb88232&scoped=true"
import script from "./CreatePasswordForm.vue?vue&type=script&lang=js"
export * from "./CreatePasswordForm.vue?vue&type=script&lang=js"
import style0 from "./CreatePasswordForm.vue?vue&type=style&index=0&id=6fb88232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb88232",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardActions,VCardText,VForm,VTextField})
